var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "voice-agent-channel-widget" },
    [
      _c(
        "md-button",
        {
          ref: "buttonRef",
          staticClass: "actionButtonBreadcrumb m-0 voice-agent-btn",
          class: ((_obj = {}), (_obj[_vm.getHealthStatus()] = true), _obj),
          staticStyle: { "min-width": "20px", "max-width": "25px" },
          on: {
            mouseenter: function ($event) {
              _vm.voiceIconHovered = true
            },
            mouseleave: function ($event) {
              _vm.voiceIconHovered = false
            },
            click: _vm.toggleDropdown,
          },
        },
        [
          _c("VoiceAgentIcon", {
            staticClass: "voice-agent-icon",
            attrs: {
              color:
                _vm.voiceIconHovered || _vm.isDropdownVisible
                  ? _vm.voiceAgentChannel
                    ? "#4ecdc4"
                    : "#888"
                  : "#3A3F48",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isDropdownVisible
        ? _c(
            "div",
            {
              staticClass: "custom-dropdown",
              class: { "dropdown-ready": _vm.dropdownReady },
              style: _vm.dropdownStyle,
            },
            [
              _c("div", { staticClass: "dropdown-content" }, [
                _vm.agents.length === 0
                  ? _c("div", { staticClass: "no-agents" }, [
                      _c("p", [_vm._v("Hiç ses ajanı bulunamadı.")]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "primary-btn",
                          on: { click: _vm.goToAgentsPage },
                        },
                        [_vm._v("Ses Ajanı Oluştur")]
                      ),
                    ])
                  : _c(
                      "div",
                      { staticClass: "agents-list" },
                      _vm._l(_vm.agents, function (agent) {
                        return _c(
                          "div",
                          {
                            key: agent.agent_id,
                            staticClass: "agent-item",
                            on: {
                              click: function ($event) {
                                return _vm.goToAgentDetail(agent.agent_id)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "agent-info" }, [
                              _vm._m(0, true),
                              _vm._v(" "),
                              _c("div", { staticClass: "agent-name" }, [
                                _vm._v(_vm._s(agent.agent_name)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "agent-actions",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "action-icon-btn call-btn",
                                    attrs: { title: "Arama Yap" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.startCall(agent)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("call"),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "action-icon-btn view-btn",
                                    attrs: { title: "Detayları Gör" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.goToAgentDetail(
                                          agent.agent_id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("visibility"),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "add-agent",
                    on: { click: _vm.goToAgentsPage },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                    _vm._v(" "),
                    _c("span", [_vm._v("Yeni Ses Ajanı Ekle")]),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isDropdownVisible
        ? _c("div", {
            staticClass: "dropdown-backdrop",
            on: { click: _vm.closeDropdown },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { position: "absolute" } },
        [
          _vm.voiceAgentChannel && _vm.selectedAgentId
            ? _c("AiVoiceAgentCallStarter", {
                ref: "voiceCallStarter",
                attrs: {
                  "default-agent-id": _vm.selectedAgentId,
                  "hide-button": true,
                  "auto-open": "",
                },
                on: {
                  close: function ($event) {
                    _vm.selectedAgentId = null
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "agent-icon-wrapper" }, [
      _c("i", { staticClass: "material-icons agent-voice-icon" }, [
        _vm._v("record_voice_over"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }